import ol from "openlayers";

export function formatArea(polygon, self) {
  let area;

  let sourceProj = self.map.getView().getProjection();
  let geom = /* @type {ol.geom.Polygon} */ polygon
    .clone()
    .transform(sourceProj, "EPSG:4326");
  let coordinates = geom.getLinearRing(0).getCoordinates();
  area = Math.abs(self.wgs84Sphere.geodesicArea(coordinates));

  let output;
  if (area > 10000) {
    const m2 = Math.round(area * 100) / 100;
    const ha = m2 / 10000;
    output = `${ha.toFixed(2)} ha`;
  } else {
    output = `${Math.round(area * 100) / 100} m<sup>2</sup>`;
  }
  return output;
}

export function formatLength(line, self) {
  let length;
  let coordinates = line.getCoordinates();
  length = 0;
  let sourceProj = self.map.getView().getProjection();
  for (let i = 0, ii = coordinates.length - 1; i < ii; ++i) {
    let c1 = ol.proj.transform(coordinates[i], sourceProj, "EPSG:4326");
    let c2 = ol.proj.transform(coordinates[i + 1], sourceProj, "EPSG:4326");
    length += self.wgs84Sphere.haversineDistance(c1, c2);
  }

  let output;
  if (length > 100) {
    output = `${Math.round((length / 1000) * 100) / 100} km`;
  } else {
    output = `${Math.round(length * 100) / 100} m`;
  }
  return output;
}

export function removeVecterDraw(self) {
  //remove element
  let element = document.querySelector(".tooltip.tooltip-static.delete");
  if (element) {
    element.style.display = "none";
  }
  //clear vector
  self.source.clear();
}

export function createMeasureTooltip(self) {
  if (self.measureTooltipElement) {
    self.measureTooltipElement.parentNode.removeChild(
      self.measureTooltipElement
    );
  }
  self.measureTooltipElement = document.createElement("div");
  self.measureTooltipElement.className = "tooltip tooltip-measure";
  self.measureTooltip = new ol.Overlay({
    element: self.measureTooltipElement,
    offset: [0, -15],
    positioning: "bottom-center",
  });
  // console.log(self.map)
  self.map.addOverlay(self.measureTooltip);
}

export function createHelpTooltip(self) {
  if (self.helpTooltipElement) {
    self.helpTooltipElement.parentNode.removeChild(self.helpTooltipElement);
  }

  self.helpTooltipElement = document.createElement("div");
  self.helpTooltipElement.className = "tooltip hidden";
  self.helpTooltip = new ol.Overlay({
    element: self.helpTooltipElement,
    offset: [15, 0],
    positioning: "center-left",
  });
  self.map.addOverlay(self.helpTooltip);
}
